export const FETCH_CLAIMS_REQUEST = 'FETCH_CLAIMS_REQUEST';
export const FETCH_CLAIMS_SUCCESS = 'FETCH_CLAIMS_SUCCESS';
export const FETCH_CLAIMS_FAILURE = 'FETCH_CLAIMS_FAILURE';

export const CREATE_CLAIM_REQUEST = 'CREATE_CLAIM_REQUEST';
export const CREATE_CLAIM_SUCCESS = 'CREATE_CLAIM_SUCCESS';
export const CREATE_CLAIM_FAILURE = 'CREATE_CLAIM_FAILURE';

export const UPDATE_CLAIM_REQUEST = 'UPDATE_CLAIM_REQUEST';
export const UPDATE_CLAIM_SUCCESS = 'UPDATE_CLAIM_SUCCESS';
export const UPDATE_CLAIM_FAILURE = 'UPDATE_CLAIM_FAILURE';

export const DELETE_CLAIM_REQUEST = 'DELETE_CLAIM_REQUEST';
export const DELETE_CLAIM_SUCCESS = 'DELETE_CLAIM_SUCCESS';
export const DELETE_CLAIM_FAILURE = 'DELETE_CLAIM_FAILURE';

export const fetchClaimsRequest = (projectId, options = {}) => {
    const { page = 1, limit = 1, search = '' } = options;
    return {
        type: FETCH_CLAIMS_REQUEST,
        payload: { projectId,page, limit, search },
      }; 
    };
export const fetchClaimsSuccess = (claims) => ({ type: FETCH_CLAIMS_SUCCESS, payload: claims });
export const fetchClaimsFailure = (error) => ({ type: FETCH_CLAIMS_FAILURE, payload: error });

export const createClaimRequest = (data, projectId) => ({ type: CREATE_CLAIM_REQUEST, payload: { data, projectId } });
export const createClaimSuccess = (claim) => ({ type: CREATE_CLAIM_SUCCESS, payload: claim });
export const createClaimFailure = (error) => ({ type: CREATE_CLAIM_FAILURE, payload: error });

export const updateClaimRequest = (id, data, projectId) => ({ type: UPDATE_CLAIM_REQUEST, payload: { id, data, projectId } });
export const updateClaimSuccess = (claim) => ({ type: UPDATE_CLAIM_SUCCESS, payload: claim });
export const updateClaimFailure = (error) => ({ type: UPDATE_CLAIM_FAILURE, payload: error });

export const deleteClaimRequest = (projectId, id) => ({ type: DELETE_CLAIM_REQUEST, payload: { id, projectId } });
export const deleteClaimSuccess = (id) => ({ type: DELETE_CLAIM_SUCCESS, payload: id });
export const deleteClaimFailure = (error) => ({ type: DELETE_CLAIM_FAILURE, payload: error });
